import React, { useState } from "react"
import PropTypes from "prop-types"
import Header from "../components/molecules/Header"
import Footer from "../components/molecules/Footer"
import "../utils/fontface.css"
import GlobalStyles from "../components/atoms/GlobalStyles"
import styled, { ThemeProvider } from "styled-components"
import { theme } from "../utils/styling"
import Navigation from "../components/molecules/Navigation"
import smoothscroll from "smoothscroll-polyfill"
import Helmet from "react-helmet"
import faviconReg from "../../static/images/favicon.png"

const Main = styled.main`
  :before {
    content: "";
    display: block;
    padding-top: 3rem;
    background-color: var(--orange);
    @media (${(props) => props.theme.breakpoints.xxl}) {
      padding-top: 0;
    }
  }
`

function Index(props) {
  // dynamic favicon biz
  let favicon = faviconReg
  const path = props.location.pathname

  const [showNav, setShowNav] = useState(true)

  const menuClickHandler = () => {
    smoothscroll.polyfill()
    if (window.scrollY) {
      window.scroll({ top: 0, left: 0, behavior: "smooth" })
      setShowNav(true)
    } else {
      setShowNav(!showNav)
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <link rel="shortcut icon" href={favicon} />
      </Helmet>
      <div id="top">
        <GlobalStyles />
        <Navigation showNav={showNav} location={props.location} />
        <div id="scroll-holder">
          <Header
            showNav={showNav}
            clickHandler={() => menuClickHandler()}
            location={props.location}
          />
          <Main>{props.children}</Main>
        </div>
        <Footer />
      </div>
    </ThemeProvider>
  )
}

Index.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Index
